import {SolicitacaoService} from './../../../service/solicitacao/solicitacao.service';
import {AuditoriaCaixaComponent} from './../../caixa/auditoria-caixa/auditoria-caixa.component';
import {ExibirConteudoCaixaComponent} from './../../caixa/exibir-conteudo-caixa/exibir-conteudo-caixa.component';
import {DialogConfirmComponent} from './../../dialog/dialog-confirm/dialog-confirm.component';
import {MatDialog} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';
import {ClienteService} from 'app/service/cliente/cliente.service';
import {CaixaService} from './../../../service/caixa/caixa.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '@alfresco/adf-core';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {FormControl, FormGroup, FormArray, FormBuilder, Validators} from '@angular/forms';
import {ClienteModel} from 'app/model/cliente/cliente.model';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {Component, OnInit, ViewChild} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as JSPM from 'jsprintmanager';

export class Atributo {
  operador: Operador[];
  descricao: String;
  valor: String;
  tipo: String;
}

export class Operador {
  operador: String;
  value: String;
}

@Component({
  selector: 'app-pesquisa-avancada-solicitacao',
  templateUrl: './pesquisa-avancada-solicitacao.component.html',
  styleUrls: ['./pesquisa-avancada-solicitacao.component.scss']
})
export class PesquisaAvancadaSolicitacaoComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  caixas: any[] = [];
  displayedColumns = ['cod', 'tpSolic', 'respAbertura', 'area', 'centroCusto',
    'dataAbertura', 'dataFechamento', 'dadosAdicionais', 'status', 'acoes'];
  dataSource = new MatTableDataSource<any[]>([]);
  public clientes: ClienteModel[];
  queryField = new FormControl();
  public inputPesquisa = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public loading = false;
  idCaixa;
  clientePesquisado;
  pesquisaForm: FormGroup;
  pesquisaFormArray: FormArray;
  submit = false;
  deData;
  clienteId;
  disabled = ['string'];
  idCaixas: any[] = [];
  buttonRelatorio = true;
  adm = false;
  acervo = false;
  solicitacao = true;
  solicitacaoUnica;
  printers: string[];
  selectedPrinter: any;
  isDefaultPrinterSelected = false;
  caixasSolicitacoes = [];
  etiquetas;
  showReport = false;
  dataInicialForm: FormControl = new FormControl('');
  dataFinalForm: FormControl = new FormControl('');

  operadorGeral: Operador[] = [
    {operador: 'igual', value: 'igual'},
    {operador: 'contenha', value: 'contenha'},
    {operador: 'comece com', value: 'comeceCom'},
    {operador: 'termine com', value: 'termineCom'},
  ];

  operadorIgual: Operador[] = [
    {operador: 'igual', value: 'igual'}
  ];

  status = new Array<Atributo>();

  constructor(private authService: AuthenticationService,
              private router: Router,
              private route: ActivatedRoute,
              private formBuilder: FormBuilder,
              private caixaService: CaixaService,
              private solicitacaoService: SolicitacaoService,
              private clienteService: ClienteService,
              private _snackBar: MatSnackBar,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    let codigo = new Atributo();
    codigo.descricao = 'Código';
    codigo.valor = 'codigo';
    codigo.operador = this.operadorGeral;
    codigo.tipo = 'string';

    let tipoSolicitacao = new Atributo();
    tipoSolicitacao.descricao = 'Tipo da Solicitacao';
    tipoSolicitacao.valor = 'tipoSolicitacao';
    tipoSolicitacao.operador = this.operadorGeral;
    tipoSolicitacao.tipo = 'string';

    let responsavelAbertura = new Atributo();
    responsavelAbertura.descricao = 'Responsável pela abertura';
    responsavelAbertura.valor = 'responsavelAbertura';
    responsavelAbertura.operador = this.operadorGeral;
    responsavelAbertura.tipo = 'string';

    let areaAtributo = new Atributo();
    areaAtributo.descricao = 'Área';
    areaAtributo.valor = 'area';
    areaAtributo.operador = this.operadorGeral;
    areaAtributo.tipo = 'string';

    let centroCusto = new Atributo();
    centroCusto.descricao = 'Centro de Custo';
    centroCusto.valor = 'centroCusto';
    centroCusto.operador = this.operadorIgual;
    centroCusto.tipo = 'igualdade';

    let dadosAdicionais = new Atributo();
    dadosAdicionais.descricao = 'Dados Adicionais';
    dadosAdicionais.valor = 'dadosAdicionais';
    dadosAdicionais.operador = this.operadorGeral;
    dadosAdicionais.tipo = 'string';

    let periodoDataAbertura = new Atributo();
    periodoDataAbertura.descricao = 'Período Data Abertura';
    periodoDataAbertura.valor = 'dataInicial';
    periodoDataAbertura.operador = this.operadorIgual;
    periodoDataAbertura.tipo = 'igualdade';

    let statusSolicitacao = new Atributo();
    statusSolicitacao.descricao = "Status da Solicitação";
    statusSolicitacao.valor = "status";
    statusSolicitacao.operador = this.operadorGeral;
    statusSolicitacao.tipo = 'string';

    this.status.push(codigo, tipoSolicitacao, responsavelAbertura,
      areaAtributo, centroCusto, dadosAdicionais, periodoDataAbertura, statusSolicitacao);

    iconRegistry.addSvgIcon('addItens', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/file-earmark-diff.svg'));
    this.route.params.subscribe(params => this.clienteId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
    this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.listarClientesUsuario();

    this.pesquisaForm = this.formBuilder.group({
      pesquisaFormArray: this.formBuilder.array([this.createItem()])
    });

    // WebSocket settings
    /*
 JSPM.JSPrintManager.auto_reconnect = true;
 JSPM.JSPrintManager.start();
 JSPM.JSPrintManager.WS.onStatusChanged = () => {
     if (this.jspmWSStatus()) {
         // get client installed printers
         JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
           this.printers = myPrinters;
           this.printers.map(element => {
             if (element === 'Microsoft XPS Document Writer') {
               this.selectedPrinter = element;
             }
           });
           console.log(this.printers);
           // this.selectedPrinter = this.printers[0];
         });
     }
 }; */
  }

  onSubmit() {
    this.submit = true;
  }

  teste(e) {
    console.log(e);
  }

  deleteSolicitacao(solicitacaoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja cancelar esta solicitação ?', from: 'listar-solicitacoes.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.cancelarSolic(solicitacaoId);
      }
    });
  }

  excluirSolic(id: number) {
    this.solicitacaoService.excluirSolicitacao(id).subscribe(() => {
      this.openSnackBarSuccess('Solicitação excluída com sucesso !');
    }, err => {
      console.error(err);
      this.openSnackBarError('Não é possível excluir a solicitação, provavelmente ela já está relacionada a outro registro no sistema.');
    })
  }

  cancelarSolic(id: number) {
    this.solicitacaoService.cancelarSolicitacao(id).subscribe(() => {
      this.openSnackBarSuccess('Solicitação cancelada com sucesso !');
    }, err => {
      console.error(err);
      this.openSnackBarError('Não é possível cancelar a solicitação !');
    })
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = true;
        this.idCaixas.push(this.dataSource.data[i]['id']);
        this.buttonRelatorio = false;
      }
    } else {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = false;
        var id = this.dataSource.data[i]['id'];
        let index = this.idCaixas.indexOf(id);
        this.idCaixas.splice(index, 1);
        this.buttonRelatorio = true;
      }
    }
  }

  checkIndividual(checked, idCaixa) {
    if (checked === true) {
      this.idCaixas.push(idCaixa);
    } else {
      let index = this.idCaixas.indexOf(idCaixa);
      this.idCaixas.splice(index, 1);
    }
    if (this.idCaixas.length > 0) {
      this.buttonRelatorio = false;
    } else {
      this.buttonRelatorio = true;
    }
  }

  onChange(e, indice) {
    this.desabilitarOperador(indice);
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      atributo: ['', [Validators.required]],
      operador: ['', Validators.required],
      conteudo: ['', [Validators.required]]
    });
  }

  goToAddCaixa(id) {
    this.loading = true;
    const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/solicitacao', idCrypt]);
  }

  relatorioSolicitacao(solicitacaoId) {
    const solicitacaoIdRecebida = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(solicitacaoId), 'pcdoc').toString());
    window.open(`relatorio-solicitacao/${solicitacaoIdRecebida}`,
      '_blank',
      'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  relacotioCaixasRealocadas(solicitacaoId) {
    const solicitacaoIdRecebida = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(solicitacaoId), 'pcdoc').toString());
    window.open(`relatorio-solicitacao-realocacao/${solicitacaoIdRecebida}`,
      '_blank',
      'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      this.solicitacaoUnica = data;
      this.loading = false;
      this.imprimirEtiquetas(this.solicitacaoUnica.id);
    }, err => {
      console.error(err);
    });
  }

  imprimirEtiquetas(solicitacaoId) {
    this.loading = true;
    this.caixasSolicitacoes = [];
    this.solicitacaoUnica.caixas.map(element => {
      this.caixasSolicitacoes.push(element.id);
    });
    this.caixaService.downloadEtiquetas(this.caixasSolicitacoes).subscribe(data => {
      this.loading = false;
      this.etiquetas = data;
      // this.doPrintZPL(data);
      this.download(data, solicitacaoId);
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Selecione apenas caixas com endereço definido !');
    });
  }

  download(text, cod) {
    var date = new Date();
    var dateFormat = date.toLocaleDateString('pt-BR');
    var nameFile = `etiquetas_caixas_solic_${cod}___` + dateFormat + '.txt';
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', nameFile);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  goToProcessamento(id) {
    this.router.navigate(['/processar-solicitacao/' + id]);
  }

  desabilitarOperador(indice) {
    console.log(indice);
    const group = this.pesquisaForm.get('pesquisaFormArray').value[indice];
    const arrayGroup = ['codArea', 'qtdItens'];
    console.log(arrayGroup);
    console.log(group);
    if (arrayGroup.includes(group.atributo)) {
      this.disabled[indice] = 'number';
    } else if (group.atributo === 'tipoSolicitacao') {
      this.disabled[indice] = 'enum';
    } else if (group.atributo === 'dataAbertura') {
      this.disabled[indice] = 'date';
    } else if (group.atributo === 'dataInicial') {
      this.disabled[indice] = 'periodoData';
    } else if (group.atributo === 'status') {
      this.disabled[indice] = 'status';
    } else {
      this.disabled[indice] = 'string';
    }
  }

  createItemStatus(): FormGroup {
    return this.formBuilder.group({
      atributo: ['', [Validators.required]],
      operador: ['igual', Validators.required],
      conteudo: ['', [Validators.required]]
    });
  }

  addItem() {
    this.disabled.push('string');
    this.pesquisaFormArray = this.pesquisaForm.get('pesquisaFormArray') as FormArray;
    this.pesquisaFormArray.push(this.createItem());
  }

  remover(indice: any) {
    if (indice > 0) {
      this.pesquisaFormArray.removeAt(indice);
      this.disabled.splice(indice, 1);
    } else {
      this.openSnackBarError('Erro ao remover. O primeiro filtro é obrigatório !');
    }
  }

  pesquisar() {
    console.log(this.dataInicialForm.value);
    console.log(this.dataFinalForm.value);
    this.loading = true;
    const arrayPesquisa: any[] = this.pesquisaForm.get('pesquisaFormArray').value;
    arrayPesquisa.forEach(el => {
      if (el.atributo === 'dataInicial') {
        el.conteudo = this.dataInicialForm.value.toString() + ':' + this.dataFinalForm.value.toString();
      }
    });
    this.solicitacaoService.pesquisaAvancadaSolicitacao(this.clienteId, arrayPesquisa).subscribe(data => {
      if (data.length === 0) {
        this.loading = false;
        this.openSnackBarError('Nenhum resultado encontrado !');
      }
      this.showReport = true;
      this.loading = false;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      data = data.map(value => {
        value.isSelected = false;
        return value;
      });
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Erro ao tentar realizar a busca.');
    });
  }

  limpar() {
    this.showReport = false;
    this.submit = false;
  }

  onSearch() {
    let value = (<HTMLSelectElement>document.getElementById('selectCliente')).value;
    this.clientePesquisado = parseInt(value);
    if (parseInt(value) == 0) {
      this.openSnackBarError('Nenhum Cliente selecionado !');
      return null;
    }
    this.getCaixas(parseInt(value));
  }

  getCaixas(idCliente: number) {
    this.loading = true;
    this.caixaService.getCaixasIdCliente(idCliente).subscribe(data => {
      this.loading = false;
      if (data.length !== 0) {
        this.inputPesquisa = true;
      } else {
        this.inputPesquisa = false;
        this.openSnackBarError(`Nenhuma caixa encontrada neste Cliente !`);
      }
      this.caixas = data;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  deleteCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: 'Deseja apagar esta caixa ? Obs: Isso apagará todos os itens da caixa.',
        from: 'listar-caixa.component.ts'
      }
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarCaixa(caixaId);
      }
    });
  }

  editCaixa(caixaId: number) {
    this.idCaixa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(caixaId), 'pcdoc').toString());
    this.router.navigate(['/editar-caixa', this.idCaixa]);
  }

  apagarCaixa(caixaId: number) {
    this.loading = true;
    this.caixaService.apagarCaixa(caixaId).subscribe(() => {
      this.loading = false;
      this.getCaixas(this.clientePesquisado);
      this.openSnackBarSuccess('Caixa excluída com sucesso !');
    }, err => {
      this.loading = false;
      this.openSnackBarError('Erro ao tentar excluír esta caixa !');
      console.error(err);
    });
  }

  incluirIntens(id) {
    this.idCaixa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/incluir-conteudo', this.idCaixa]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  // Check JSPM WebSocket status
  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      //alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      alert('JSPM has blocked this website!');
      return false;
    }
  }

  // Do Zebra ZPL printing...
  doPrintZPL(text) {
    if (this.jspmWSStatus()) {
      // Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();
      // Set Printer type (Refer to the help, there many of them!)
      //https://www.neodynamic.com/Products/Help/JSPrintManager4.0/articles/jsprintmanager.html#client-printer-types
      if (this.isDefaultPrinterSelected) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      // Set content to print...
      //Create Zebra ZPL commands for sample label
      var cmds = text;
      cpj.printerCommands = cmds;
      // Send print job to printer!
      cpj.sendToClient();
    }
  }

  downloadRelatorioSolicitacoes() {
    const arrayPesquisa: any[] = this.pesquisaForm.get('pesquisaFormArray').value;
    arrayPesquisa.forEach(el => {
      if (el.atributo === 'dataInicial') {
        el.conteudo = this.dataInicialForm.value.toString() + ':' + this.dataFinalForm.value.toString();
      }
    });
    this.loading = true;
    this.solicitacaoService.downloadRelatorioSolicitacoes(this.clienteId, arrayPesquisa).subscribe(data => {
      this.downloadFile(data);
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    })
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    let date = this.getFormattedDateTime();
    const fileName: string = `relatorio-solicitacoes-${date}.xlsx`;
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  getFormattedDateTime() {
    var date = new Date();
  
    var day = this.padZero(date.getDate());
    var month = this.padZero(date.getMonth() + 1); // Os meses em JavaScript são baseados em zero, então adicionamos +1
    var year = date.getFullYear();
    var hours = this.padZero(date.getHours());
    var minutes = this.padZero(date.getMinutes());
    var seconds = this.padZero(date.getSeconds());
  
    return day + "_" + month + "_" + year + "_" + hours + "_" + minutes + "_" + seconds;
  }
  
  padZero(number) {
    return number.toString().padStart(2, '0');
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/pesquisa-avancada-solicitacao/pesquisa-avancada-solicitacao.component.ts